import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Organization } from '../../../../model/organization';
import { Arena } from '../../../../model/arena';
import { RodeoService } from '../../../../services/rodeo.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { ToastController, PopoverController, LoadingController, NavController, AlertController, Popover, PopoverCmp } from 'ionic-angular';
import { GoogleService } from '../../../../services/google.service';
import { SearchBoxComponent } from './search-box.component';
import { RodeoEventOrder } from '../../../../model/rodeoEventOrder';
import { RoundStyle } from '../../../../model/roundStyle';
import { Sidepot } from '../../../../model/sidepot';
import { Exhibition } from '../../../../model/exhibition';
import { RodeoEventService } from '../../../../services/rodeoEvent.service';
import { Secretary } from '../../../../model/secretary';
import { NewPayoutConfig } from './new-payout-config';
import { RodeoEventCarryOver } from '../../../../model/rodeoEventCarryOver';
import { JudgePopup } from './judge-popup';
import { JudgeService } from '../../../../services/judge.service';
import { Judge, JudgeCategory } from '../../../../model/judge';
import { ImageService } from '../../../../services/image.service';
import { NewCarryOver } from './new-carryover';
import { AccountHelper } from '../../../../lib/accountHelper';
import { PayoutConfig } from '../../../../model/payoutConfig';
import { PayoutSource } from '../../../../model/payout-source';
import { PriceTier } from 'model/price-tier.model';
import { AccountGroupService } from '../../../../services/accountGroup.service';
import { AccountGroup, AccountsGroup } from '../../../../model/accountGroup';
import { BehaviorSubject } from 'rxjs';
import { Account } from '../../../../model/account';
import { UserSearchPopover } from '../../../../pages/search/user-search';
import { UserService } from '../../../../services/user.service';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'staff-settings',
    templateUrl: 'settings.html'
})
export class SettingsSection implements OnInit {
    @ViewChild(SearchBoxComponent) searchBox;
    @ViewChild("arenaSearch") arenaSearch: ElementRef;

    _rodeo: Rodeo = new Rodeo();
    _sanctionedOrganizations: Organization[] = [];
    _organizations: Organization[] = [];
    _secretaries: Secretary[] = [];
    _arenas: Arena[] = [];
    _roundStyles: RoundStyle[] = [{ id: 1, name: "Progressive" }, { id: 2, name: "Guaranteed" }];
    _viewMode: string = 'general';
    @Input() disciplines: string[] = [];
    @Input() progressionOrderFormats: string[] = [];

    carryOvers: any[] = [];

    rodeoSettingsForm: FormGroup;
    validationMessages: any[];

    allSchedules: RodeoEventSchedule[] = [];

    accountHelper = AccountHelper.instance();

    payoutTypes: any[];
    payoutModes: any[];

    selectedRodeoEvent: any;

    searchBoxVisible: boolean;
    submitAttempt: boolean;

    popoverActive: boolean;

    judges: { [key: number]: Judge[] };
    judgeCategories: { [key: number]: JudgeCategory[] };
    judgePenalties: { [key: number]: JudgeCategory[] };
    rodeoEventDisplayNames: any[] = [];

    agreementFile: any;

    orgStaff: Account[] = [];
    staffMap: { [accountOneId: number]: { name: string; email: string; phone: string } } = {};

    rodeoSecretaries = new BehaviorSubject<AccountGroup | null>(null);
    rodeoContractors = new BehaviorSubject<AccountGroup | null>(null);

    showStaff = true;

    isPopoverOpen = false;

    selectedTimeZone: string = 'America/Chicago';

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this.allSchedules = [];
            this.rodeoEventDisplayNames = [];
            Object.assign(this._rodeo, rodeo);

            this.payoutTypes = ['Straight', 'Ds'];
            this.payoutModes = ['Average', 'Aggregate', 'Per Round', 'Overall', 'Bottoms Up'];

            this.addSchedules();
            this.organizationUpdated();

            this.selectedTimeZone = this.rodeo.rodeoTimezone ? this.rodeo.rodeoTimezone : 'Not Selected';
            // console.log('selected time zone', this.selectedTimeZone);
            this.setFormDateFields();

            if (!this._rodeo.secretary)
                (this._rodeo.secretary as any) = "";

            let index = 0;
            this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                rodeoEvent.ageCheckDate = this.dateHelper.stripTimezone(rodeoEvent.ageCheckDate);
                this.updateCutoffs(rodeoEvent);
                if (!this.selectedRodeoEvent)
                    this.selectedRodeoEvent = rodeoEvent;

                if (!rodeoEvent.ropingFormat)
                    rodeoEvent.ropingFormat = 'Pick';

                this.rodeoEventDisplayNames[rodeoEvent.id] = rodeoEvent.displayName;

                rodeoEvent.schedules.forEach(schedule => {
                    schedule.scheduledDate = this.dateHelper.stripTimezone(schedule.scheduledDate);
                    this.allSchedules.push(schedule);
                });


                rodeoEvent.sidepots.forEach((sidepot) => {
                    if (!sidepot.payoutType || !this.payoutTypes.some(x => x.toLocaleLowerCase() == sidepot.payoutType.toLocaleLowerCase())) {
                        sidepot.payoutType = "Ds";
                    }

                    if (!sidepot.payoutMode || !this.payoutModes.some(x => x.toLocaleLowerCase() == sidepot.payoutMode.toLocaleLowerCase())) {
                        sidepot.payoutMode = "Overall";
                    }
                })


                this.carryOvers[index] = rodeoEvent.carryOvers;
                if (this.roundStyles) {
                    rodeoEvent.roundStyle = this.roundStyles.filter(x => x.id == rodeoEvent.roundStyleId)[0];
                }

                // if (!this.rodeo.payoutConfigs || this.rodeo.payoutConfigs.filter(x => x.sources.some(y => y.rodeoEventId == rodeoEvent.id)).length == 0) {
                //     this.addDefaultPayoutConfigsForClass(rodeoEvent);
                // }


                if (!rodeoEvent.priceTiers || rodeoEvent.priceTiers.length == 0) {
                    this.addNewPriceTier(index);
                } else {
                    rodeoEvent.priceTiers = rodeoEvent.priceTiers.map(x => {
                        x.startDate = this.dateHelper.stripTimezone(x.startDate);
                        x.endDate = this.dateHelper.stripTimezone(x.endDate);
                        return x;
                    });
                }

                index++;
            });

            this._rodeo.payoutConfigs.forEach((payoutConfig) => {
                if (payoutConfig.divisionOffsets) {
                    payoutConfig.divisionOffsetArray = payoutConfig.divisionOffsets.split(",");
                }
            });

            if ((this._rodeo.rodeoTimezoneOffset == 0 || this._rodeo.registrationTimezoneOffset == 0) && this._rodeo.arena.name !== "") {
                this.googleService.getCoordinates(this._rodeo.arena.name)
                    .then(data => {
                        if ((data as any).error_message == null) {
                            var location = (data as any).results[0].geometry.location.lat * 1 + ',' + (data as any).results[0].geometry.location.lng;
                            this.googleService.getTimezone(location, new Date().getUTCSeconds())
                                .then(data2 => {
                                    if (this._rodeo.rodeoTimezoneOffset == 0)
                                        this._rodeo.rodeoTimezoneOffset = (data2 as any).rawOffset / 3600;

                                    if (this._rodeo.registrationTimezoneOffset == 0)
                                        this._rodeo.registrationTimezoneOffset = (data2 as any).rawOffset / 3600;
                                })
                        }
                    });
            }
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set sanctionedOrganizations(organizations: Organization[]) {
        if (organizations != null) {
            this._sanctionedOrganizations = organizations.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        }
    }
    get sanctionedOrganizations(): Organization[] {
        return this._sanctionedOrganizations;
    }

    @Input()
    set organizations(organizations: Organization[]) {
        if (organizations != null) {
            this._organizations = organizations.sort((a,b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        }
    }
    get organizations(): Organization[] {
        return this._organizations;
    }


    @Input()
    set secretaries(secretaries: Secretary[]) {
        if (secretaries != null) {
            this._secretaries = secretaries;
        }
    }
    get secretaries(): Secretary[] {
        return this._secretaries;
    }

    @Input()
    set arenas(arenas: Arena[]) {
        if (arenas != null) {
            this._arenas = arenas;
        }
    }
    get arenas(): Arena[] {
        return this._arenas;
    }

    @Input()
    set roundStyles(roundStyles: RoundStyle[]) {
        if (roundStyles != null) {
            this._roundStyles = roundStyles;

            if (this.rodeo != null) {
                this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                    rodeoEvent.roundStyle = this.roundStyles.filter(x => x.id == rodeoEvent.roundStyleId)[0];
                });
            }
        }
    }
    get roundStyles(): RoundStyle[] {
        return this._roundStyles;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    @Input()
    set rodeoOrgStaff(rodeoOrgstaff: Account[]) {
        if (rodeoOrgstaff.length > 0) {
            this.orgStaff = rodeoOrgstaff;

            this.orgStaff.forEach((staff) => {
                this.staffMap[staff.id] = {
                    name: `${staff.firstName} ${staff.lastName}`,
                    email: staff.emailAddress || 'N/A',
                    phone: staff.phone || 'N/A'
                };
            });
        }

        if (this.rodeo && this.rodeo.id) {
            this.accountGroupService.getRodeoStaff(this.rodeo.id).then((data) => {
                // Emit existing values if already present
                if (data.length > 0) {
                    const secretaries = data.find(x => x.name.includes('Secretaries'));
                    this.rodeoSecretaries.next(secretaries);
                    this.mapGroupAccounts(secretaries);
    
                    const contractors = data.find(x => x.name.includes('Contractors'));
                    this.rodeoContractors.next(contractors);
                    this.mapGroupAccounts(contractors);
                } else {
                    this.createRodeoStaffGroup('secretaries');
                    this.createRodeoStaffGroup('contractors');
                }
            });
        } else {
            this.createRodeoStaffGroup('secretaries');
            this.createRodeoStaffGroup('contractors');
        }
    }
    get rodeoOrgStaff(): Account[] {
        return this.orgStaff;
    }

    constructor(formBuilder: FormBuilder, private rodeoService: RodeoService, private rodeoEventService: RodeoEventService, private alertMessager: AlertMessager,
        private googleService: GoogleService, private loadingController: LoadingController, private nav: NavController, private alert: AlertController,
        private toastController: ToastController, private popoverController: PopoverController, private judgeService: JudgeService, private imageService: ImageService, private accountGroupService: AccountGroupService, private userService: UserService, public dateHelper: DateHelperService) {
        this.rodeoSettingsForm = formBuilder.group({
            name: new FormControl('name', Validators.compose([
                Validators.required
            ])),
            arenaName: new FormControl('arenaName', Validators.required),
            organization: new FormControl('organization', Validators.required),
            sanctionedOrgs: new FormControl('sanctionedOrgs'),
            entryCost: new FormControl('entryCost', Validators.required),
            rounds: new FormControl('rounds', Validators.min(1)),
            displayName: new FormControl('displayName', Validators.required),
            addedMoney: new FormControl('addedMoney', Validators.required),
            guaranteedMoney: new FormControl('guaranteedMoney', Validators.required),
            allowBuddies: new FormControl('allowBuddies', Validators.required),
            website: new FormControl('website', Validators.required),
            phone: new FormControl('phone', Validators.required),
            registrationStartDate: new FormControl(undefined, Validators.required),
            lateRegistrationStartDate: new FormControl(undefined, Validators.required),
            registrationEndDate: new FormControl(undefined, Validators.required),
            tradeDeadline: new FormControl(undefined, Validators.required),
            tradeCap: new FormControl('tradeCap', Validators.required),
            buddyMax: new FormControl('buddyMax', Validators.required),
            officeFee: new FormControl('officeFee', Validators.min(0)),
            lateFee: new FormControl('lateFee', Validators.min(0)),
            schedules: new FormControl('schedules', Validators.required),
            paymentPlanFee: new FormControl('', Validators.min(0)),
            paymentPlanMonthlyDueDate: new FormControl(0, [Validators.min(0), Validators.max(31)]),
            paymentPlanEnrollmentStartDate: new FormControl(''),
            paymentPlanEnrollmentEndDate: new FormControl(''),
            checksDueBy: new FormControl(''),
            paymentPlanDueBy: new FormControl(''),
            allowPermitsToEnter: new FormControl('allowPermitsToEnter'),
            allowEntryComments: new FormControl(false)
        });

        this.rodeoSettingsForm.get('registrationStartDate').valueChanges.subscribe(date => {
            //copy date to first price tier start date for each event
            if (this._rodeo.rodeoEvents) {
                this._rodeo.rodeoEvents.forEach(rodeoEvent => {
                    if (rodeoEvent.priceTiers && rodeoEvent.priceTiers.length > 0) {
                        rodeoEvent.priceTiers = rodeoEvent.priceTiers
                            .sort((a, b) => {
                                if (a.startDate === b.startDate) {
                                    return a.endDate > b.endDate ? 1 : -1;
                                }
                                return a.startDate > b.startDate ? 1 : -1;
                            });

                        rodeoEvent.priceTiers[0].startDate = date;
                    }
                });
            }
        });

        this.rodeoSettingsForm.get('registrationEndDate').valueChanges.subscribe(date => {
            //copy date to last price tier end date for each event
            if (this._rodeo.rodeoEvents) {
                this._rodeo.rodeoEvents.forEach(rodeoEvent => {
                    if (rodeoEvent.priceTiers && rodeoEvent.priceTiers.length > 0) {
                        rodeoEvent.priceTiers = rodeoEvent.priceTiers
                            .sort((a, b) => {
                                if (a.startDate === b.startDate) {
                                    return a.endDate > b.endDate ? 1 : -1;
                                }
                                return a.startDate > b.startDate ? 1 : -1;
                            });

                        rodeoEvent.priceTiers[rodeoEvent.priceTiers.length - 1].endDate = date;
                    }
                });
            }
        });

        this.validationMessages = [
            { name: 'name', type: 'required', message: 'Rodeo name is required.' },
            { name: 'officeFee', type: 'min', message: 'Office Fee must be at least 0.' },
            { name: 'lateFee', type: 'min', message: 'Late Fee must be at least 0.' },
            { name: 'paymentPlanFee', type: 'min', message: 'Payment Plan Fee must be at least 0.' },
            { name: 'arenaName', type: 'required', message: 'Arena name is required.' },
            { name: 'organization', type: 'required', message: 'Organization is required.' },
            { name: 'entryCost', type: 'required', message: 'Entry cost is required.' },
            { name: 'rounds', type: 'required', message: 'Round count must be above 0.' },
            { name: 'addedMoney', type: 'required', message: 'Added money is required.' },
            { name: 'guaranteedMoney', type: 'required', message: 'Guaranteed money is required.' },
            { name: 'paymentPlanMonthlyDueDate', type: 'max', message: 'Payment plan due date is invalid.' },
        ];
    }

    ngOnInit(): void {
        // console.log(this.viewMode);
        this.getJudges(-1);
    }

    updateSplits(rodeoEvent: any) {
        if (!rodeoEvent.leaderDivisions)
            return;

        if (!rodeoEvent.divisionOffsets)
            rodeoEvent.divisionOffsets = [];

        for (let i = 0; i < rodeoEvent.maxDivisions; i++) {
            if (rodeoEvent.divisionOffsets.length <= i)
                rodeoEvent.divisionOffsets.push(0);
        }
    }

    updateCutoffs(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.rounds <= 1)
            return;

        if (!rodeoEvent.cutOffTimes)
            rodeoEvent.cutOffTimes = [];

        for (let i = 0; i < rodeoEvent.rounds - 1; i++) {
            if (rodeoEvent.cutOffTimes.length <= (i + 1))
                rodeoEvent.cutOffTimes.push("0");
        }
    }

    addDefaultPayoutConfigsForClass(rodeoEvent) {
        let newPayoutConfig = new PayoutConfig();
        newPayoutConfig.id = Math.floor(Math.random() * -1000000000);
        newPayoutConfig.name = rodeoEvent.maxDivisions > 1 ? 'Ds' : 'Round 1';
        newPayoutConfig.maxDivisions = rodeoEvent.maxDivisions;
        newPayoutConfig.divisionOffsetArray = rodeoEvent.divisionOffsets;
        newPayoutConfig.divisionOffsets = rodeoEvent.divisionOffsets.join(',');
        newPayoutConfig.includePenalties = rodeoEvent.maxDivisions > 1 ? false : true;
        newPayoutConfig.places = 3;
        newPayoutConfig.payoutFormatId = this.rodeo.organization.payoutFormats[0].payoutFormat.id;
        newPayoutConfig.rodeoId = this.rodeo.id;
        newPayoutConfig.uniqueRunsOnly = true;
        newPayoutConfig.onXRounds = 0;

        let newPayoutSource = new PayoutSource();
        newPayoutSource.amountToPot = Math.round(+rodeoEvent.entryCost * .8);
        newPayoutSource.rodeoEventId = rodeoEvent.id;
        newPayoutSource.round = 0;
        newPayoutSource.onXRounds = 0;

        newPayoutConfig.sources = [newPayoutSource];
        this.rodeo.payoutConfigs.push(newPayoutConfig);
        // console.log('added default payout config for class: ', rodeoEvent.displayName);
    }

    matchStrings(a: string, b:string) {
        return a.toLocaleLowerCase() == b.toLocaleLowerCase();
    }

    organizationUpdated() {
        this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.sidepots.forEach((sidepot) => {
                if (!sidepot.payoutFormat || !this._rodeo.organization.payoutFormats.some(x => x.payoutFormat.id == sidepot.payoutFormat.id))
                    sidepot.payoutFormat = this._rodeo.organization.payoutFormats[0].payoutFormat;
            })
        })
    }

    getEntryCount(rodeoEvent: RodeoEvent, schedule: RodeoEventSchedule) {
        return rodeoEvent.registrations.filter(x => x.scheduleIds[0] == schedule.id).length;
    }

    addSchedules() {
        this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
            this.addRodeoEvent(rodeoEvent, false);
            let rodeoEventIndex = this._rodeo.rodeoEvents.indexOf(rodeoEvent);

            rodeoEvent.sidepots.forEach((sidepot) => {
                this.addNewSidepot(rodeoEventIndex, rodeoEvent.sidepots.indexOf(sidepot), false);
            })

            rodeoEvent.schedules.forEach((schedule) => {
                let scheduleIndex = rodeoEvent.schedules.indexOf(schedule);
                this.addNewSchedule(rodeoEventIndex, scheduleIndex, false);
            })

            if (!rodeoEvent.eventOrders || rodeoEvent.eventOrders.length == 0)
                this.setupNewRodeoEventOrders(rodeoEvent);
        });

        this._rodeo.exhibitions.forEach((exhibition) => {
            this.addNewExhibition(this._rodeo.exhibitions.indexOf(exhibition), false);
        });
    }

    addNewCarryOver(rodeoEvent) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(NewCarryOver, {
            fromRodeoEvent: rodeoEvent,
            rodeo: this.rodeo
        }, {
            cssClass: 'new-carryover'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data) {
                rodeoEvent.carryOvers.push(data);
            }
        })
    }

    matchInts(a: number, b: number) {
        return a == b;
    }

    matchEventTypes(a: string, b: string) {
        return a == b;
    }

    matchRoundStyles(a: RoundStyle, b: RoundStyle) {
        return a.id == b.id;
    }

    matchPayoutFormats(a, b) {
        return a.id == b.id;
    }

    matchCarryOvers(a: RodeoEventCarryOver, b: RodeoEventCarryOver) {
        return a.carryOverId == b.carryOverId;
    }

    matchOrgs(a: any, b: any) {
        return a.id == b.id;
    }

    matchRodeoEvents(a: any, b: any) {
        return a.id == b.id && a.displayName == b.displayName;
    }

    compareSecretaries(a: any, b: any): boolean {
        return a && b ? a.id === b.id : a === b;
    }

    compareContractors(a: any, b: any): boolean {
        return a && b ? a.id === b.id : a === b;
    }

    addRodeoEvent(rodeoEvent: RodeoEvent, newRodeo: boolean = true) {
        if (newRodeo) {
            this._rodeo.rodeoEvents.push(rodeoEvent);
        }

        let index = this._rodeo.rodeoEvents.indexOf(rodeoEvent);

        this.rodeoSettingsForm.registerControl('entryCost_' + index, new FormControl('entryCost_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('entryLateFee_' + index, new FormControl('entryLateFee_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('rounds_' + index, new FormControl('rounds_' + index, [Validators.required, Validators.min(1)]));
        this.rodeoSettingsForm.registerControl('rotationMax_' + index, new FormControl('rotationMax_' + index, [Validators.required, Validators.min(0)]));
        this.rodeoSettingsForm.registerControl('progressiveAfter_' + index, new FormControl('progressiveAfter_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('enableDs_' + index, new FormControl('enableDs_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('dMax_' + index, new FormControl('dMax_' + index, [Validators.required, Validators.min(1)]));
        this.rodeoSettingsForm.registerControl('divisionOffset_' + index, new FormControl('divisionOffset_' + index, [Validators.required, Validators.min(.05)]));
        this.rodeoSettingsForm.registerControl('shortGo_' + index, new FormControl('shortGo_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('reverseSecondRound_' + index, new FormControl('reverseSecondRound_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('reverseSecondRoundDragOnly_' + index, new FormControl('reverseSecondRoundDragOnly_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('fallbackToFill_' + index, new FormControl('fallbackToFill_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('fallbackToPlace_' + index, new FormControl('fallbackToPlace_' + index, [Validators.required]));
        this.rodeoSettingsForm.registerControl('shortGoMax_' + index, new FormControl('shortGoMax_' + index, [Validators.required, Validators.min(1)]));
        this.rodeoSettingsForm.registerControl('maxEntriesPerContestant_' + index, new FormControl('maxEntriesPerContestant_' + index, [Validators.required, Validators.min(1)]));
        this.rodeoSettingsForm.registerControl('maxEntries_' + index, new FormControl('maxEntries_' + index, [Validators.required, Validators.min(1)]));
        this.rodeoSettingsForm.registerControl('minAge_' + index, new FormControl('minAge_' + index, [Validators.required, Validators.min(0)]));
        this.rodeoSettingsForm.registerControl('maxAge_' + index, new FormControl('maxAge_' + index, [Validators.required, Validators.min(0)]));
        this.rodeoSettingsForm.registerControl('addedMoney_' + index, new FormControl('addedMoney_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('guaranteedMoney_' + index, new FormControl('guaranteedMoney_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('displayName_' + index, new FormControl('displayName_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('eventOrderSlack_' + index, new FormControl('eventOrderSlack_' + index, Validators.required));
        this.rodeoSettingsForm.registerControl('eventOrderPerf_' + index, new FormControl('eventOrderPerf_' + index, Validators.required));

        this.validationMessages.push(
            { name: 'entryCost_' + index, type: 'required', message: 'Entry fee is required.' },
            { name: 'entryLateFee_' + index, type: 'required', message: 'Entry late fee is required.' },
            { name: 'rounds_' + index, type: 'required', message: 'Round count is required.' },
            { name: 'rounds_' + index, type: 'min', message: 'Round count must be above 0.' },
            { name: 'rotationMax_' + index, type: 'required', message: 'Rotation count is required.' },
            { name: 'rotationMax_' + index, type: 'min', message: 'Rotation count must be equal to or  above 0.' },
            { name: 'minAge_' + index, type: 'required', message: 'Min Age must be above 0' },
            { name: 'maxAge_' + index, type: 'required', message: 'Max Age must be above 0' },
            { name: 'enableDs_' + index, type: 'required', message: 'Enable Ds is requried' },
            { name: 'dMax_' + index, type: 'required', message: 'Max Divsions is requried' },
            { name: 'dMax_' + index, type: 'min', message: 'Max Divsions must be above 0.' },
            { name: 'divisionOffset_' + index, type: 'required', message: 'Division offset is required.' },
            { name: 'divisionOffset_' + index, type: 'min', message: 'Division offset must be above 0.' },
            { name: 'shortGo_' + index, type: 'required', message: 'Short Go is requried' },
            { name: 'reverseSecondRound_' + index, type: 'required', message: 'Reverse Second Round is requried' },
            { name: 'reverseSecondRoundDragOnly_' + index, type: 'required', message: 'Reverse Second Round Drag Only is requried' },
            { name: 'fallbackToFill_' + index, type: 'required', message: 'Fallback to fill is requried' },
            { name: 'fallbackToPlace_' + index, type: 'required', message: 'Fallback to place is requried' },
            { name: 'shortGoMax_' + index, type: 'required', message: 'Short Go max runs is required.' },
            { name: 'shortGoMax_' + index, type: 'min', message: 'Short Go max runs must be above 0.' },
            { name: 'maxEntriesPerContestant_' + index, type: 'required', message: 'Max entries per contestant is required.' },
            { name: 'maxEntriesPerContestant_' + index, type: 'min', message: 'Max entries per contestant must be above 0.' },
            { name: 'maxEntries_' + index, type: 'required', message: 'Max entries is required.' },
            { name: 'maxEntries_' + index, type: 'min', message: 'Max entries must be above 0.' },
            { name: 'eventOrderSlack_' + index, type: 'required', message: 'Slack order is required.' },
            { name: 'eventOrderPerf_' + index, type: 'required', message: 'Perf order is required.' },
            { name: 'addedMoney_' + index, type: 'required', message: 'Added money value is required.' },
            { name: 'guaranteedMoney_' + index, type: 'required', message: 'Guaranteed money value is required.' },
            { name: 'displayName_' + index, type: 'required', message: 'Display Name value is required.' },
        );
    }

    isRoughStock(rodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    addNewSchedule(rodeoIndex: number, scheduleIndex: number, addToEvent: boolean = true) {
        if (addToEvent) {
            let newSchedule = new RodeoEventSchedule();
            newSchedule.name = 'Perf ' + (scheduleIndex + 1);
            newSchedule.scheduledDate = this.dateHelper.stripTimezone(new Date().toLocaleString());
            newSchedule.minSize = this.isRoughStock(this._rodeo.rodeoEvents[rodeoIndex]) ? 0 : 6;
            newSchedule.maxSize = 10;
            newSchedule.priority = 0;
            newSchedule.runs = [];

            this._rodeo.rodeoEvents[rodeoIndex].schedules.push(newSchedule);
            this.allSchedules.push(newSchedule);
        }

        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_scheduleName_' + scheduleIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_scheduleName_' + scheduleIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_scheduleDate_' + scheduleIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_scheduleDate_' + scheduleIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_scheduleSize_' + scheduleIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_scheduleSize_' + scheduleIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_scheduleMinSize_' + scheduleIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_scheduleMinSize_' + scheduleIndex, Validators.required));

        this.validationMessages.push(
            { name: 'rodeoEvent_' + rodeoIndex + '_scheduleName_' + scheduleIndex, type: 'required', message: 'Schedule name is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_scheduleDate_' + scheduleIndex, type: 'required', message: 'Schedule date is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_scheduleSize_' + scheduleIndex, type: 'required', message: 'Performance max size is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_scheduleMinSize_' + scheduleIndex, type: 'required', message: 'Performance min size is required.' }
        );
    }

    removeSchedule(schedule: RodeoEventSchedule, rodeoEvent: RodeoEvent) {
        rodeoEvent.schedules = rodeoEvent.schedules.filter(x => x != schedule);
    }

    removeCarryOver(carryOver: RodeoEventCarryOver, rodeoEvent: RodeoEvent, index: number) {
        rodeoEvent.carryOvers = rodeoEvent.carryOvers.filter(x => x != carryOver);
        this.carryOvers[index] = this.carryOvers[index].filter(x => x != carryOver);
    }

    addNewExhibition(exhibitionIndex, addToSchedule: boolean = true) {
        if (addToSchedule) {
            // this.modifyExistingExhibitions(exhibitionIndex);

            let newExhibition = new Exhibition();
            newExhibition.name = 'Group ' + (exhibitionIndex + 1);
            newExhibition.date = new Date(new Date().getTime()).toISOString().substring(0, '2011-10-05T14:48'.length);
            newExhibition.maxRuns = 30;
            newExhibition.maxEntriesPerContestant = 6;
            newExhibition.cost = 5;
            newExhibition.bulkCost = 12;
            newExhibition.bulkThreshold = 3;

            this._rodeo.exhibitions.push(newExhibition);
        }

        this.rodeoSettingsForm.registerControl('_exhibitionName_' + exhibitionIndex, new FormControl('_exhibitionName_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionDate_' + exhibitionIndex, new FormControl('_exhibitionDate_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionMaxRuns_' + exhibitionIndex, new FormControl('_exhibitionMaxRuns_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionMaxEntriesPerContestant_' + exhibitionIndex, new FormControl('_exhibitionMaxEntriesPerContestant_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionCost_' + exhibitionIndex, new FormControl('_exhibitionCost_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionBulkCost_' + exhibitionIndex, new FormControl('_exhibitionBulkCost_' + exhibitionIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('_exhibitionBulkThreshold_' + exhibitionIndex, new FormControl('_exhibitionBulkThreshold_' + exhibitionIndex, Validators.required));

        this.validationMessages.push(
            { name: '_exhibitionName_' + exhibitionIndex, type: 'required', message: 'Exhibition name is required.' },
            { name: '_exhibitionDate_' + exhibitionIndex, type: 'required', message: 'Exhibition date is required.' },
            { name: '_exhibitionMaxRuns_' + exhibitionIndex, type: 'required', message: 'Exhibition max runs is required.' },
            { name: '_exhibitionMaxEntriesPerContestant_' + exhibitionIndex, type: 'required', message: 'Exhibition max entries per contestant is required.' },
            { name: '_exhibitionCost_' + exhibitionIndex, type: 'required', message: 'Exhibition cost is required.' },
            { name: '_exhibitionBulkCost_' + exhibitionIndex, type: 'required', message: 'Exhibition bulk cost is required.' },
            { name: '_exhibitionBulkThreshold_' + exhibitionIndex, type: 'required', message: 'Exhibition bulk cost quantity is required.' }
        );
    }

    removeExhibition(exhibition: Exhibition) {
        const removedIndex = this._rodeo.exhibitions.indexOf(exhibition);
        // First, shift existing exhibitions after removed index to prior index
        this.shiftExhibitionValues(removedIndex);

        // Once shifted, remove exhibition
        this._rodeo.exhibitions = this._rodeo.exhibitions.filter(x => x != exhibition);

        // Wait for change detection before removing controls
        setTimeout(() => {
            this.removeExhibitionControls(this._rodeo.exhibitions.length); // Remove the last set of controls
        });
    }
    
   
    shiftExhibitionValues(startIndex: number) {
        for (let i = startIndex; i < this._rodeo.exhibitions.length - 1; i++) {
            let nextIndex = i + 1;
            this.copyControlValue(nextIndex, i, `_exhibitionName_`);
            this.copyControlValue(nextIndex, i, `_exhibitionDate_`);
            this.copyControlValue(nextIndex, i, `_exhibitionMaxRuns_`);
            this.copyControlValue(nextIndex, i, `_exhibitionMaxEntriesPerContestant_`);
            this.copyControlValue(nextIndex, i, `_exhibitionCost_`);
            this.copyControlValue(nextIndex, i, `_exhibitionBulkCost_`);
            this.copyControlValue(nextIndex, i, `_exhibitionBulkThreshold_`);
        }
    }

    copyControlValue(fromIndex: number, toIndex: number, field: string) {
        if (this.rodeoSettingsForm.contains(`${field}${fromIndex}`)) {
            const oldControl = this.rodeoSettingsForm.get(`${field}${fromIndex}`);
            const newControl = new FormControl(oldControl.value, Validators.required);
            this.rodeoSettingsForm.removeControl(`${field}${toIndex}`);
            this.rodeoSettingsForm.addControl(`${field}${toIndex}`, newControl);
        }
    }

    removeExhibitionControls(exhibitionIndex: number) {
        this.rodeoSettingsForm.removeControl(`_exhibitionName_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionDate_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionMaxRuns_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionMaxEntriesPerContestant_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionCost_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionBulkCost_${exhibitionIndex}`);
        this.rodeoSettingsForm.removeControl(`_exhibitionBulkThreshold_${exhibitionIndex}`);

        this.validationMessages = this.validationMessages.filter(msg =>
            !msg.name.startsWith(`_exhibitionName_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionDate_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionMaxRuns_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionMaxEntriesPerContestant_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionCost_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionBulkCost_${exhibitionIndex}`) &&
            !msg.name.startsWith(`_exhibitionBulkThreshold_${exhibitionIndex}`)
        );
    }
    

    addNewRodeoEventPayoutConfig(rodeoEvent) {
        this.addNewPayoutConfig((data) => {
            if (!rodeoEvent.payoutConfigs)
                rodeoEvent.payoutConfigs = [];

            rodeoEvent.payoutConfigs.push({ rodeoEventId: rodeoEvent.id, name: data.name, payoutConfig: data, payoutConfigId: data.id });
        })
    }

    addNewSidepotPayoutConfig(sidepot) {
        this.addNewPayoutConfig((data) => {
            if (!sidepot.payoutConfigs)
                sidepot.payoutConfigs = [];

            sidepot.payoutConfigs.push({ sidepotId: sidepot.id, name: data.name, payoutConfig: data, payoutConfigId: data.id });
        })
    }

    addNewPayoutConfig(callback) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(NewPayoutConfig, {
            organization: this.rodeo.organization,
            rodeo: this.rodeo
        }, {
            cssClass: 'page-payout-config'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            // console.log("data: ", data);

            if (data) {
                callback(data);
            }
        })
    }

    editPayoutConfig(payoutConfig) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(NewPayoutConfig, {
            payoutConfig: payoutConfig,
            organization: this.rodeo.organization,
            rodeo: this.rodeo
        }, {
            cssClass: 'page-payout-config'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            // console.log("data: ", data);

            if (data) {
                payoutConfig = data;
            }
        })
    }

    addNewSidepot(rodeoIndex: number, sidepotIndex: number, addToEvent: boolean = true) {
        if (addToEvent) {
            let newSidepot = new Sidepot();
            newSidepot.name = 'Example';
            newSidepot.cost = 25;
            newSidepot.maleAgeFloor = 0;
            newSidepot.maleAgeCap = 1000;
            newSidepot.femaleAgeFloor = 0;
            newSidepot.femaleAgeCap = 1000;
            newSidepot.addedMoney = 0;
            newSidepot.officeFee = 0;

            newSidepot.payoutFormat = this._rodeo.organization.payoutFormats[0].payoutFormat;
            newSidepot.payoutMode = this.payoutModes[0];
            newSidepot.payoutType = this.payoutTypes[0];
            newSidepot.places = 1;
            newSidepot.placesEveryXRuns = 0;
            newSidepot.payoutPercentage = 80;

            this._rodeo.rodeoEvents[rodeoIndex].sidepots.push(newSidepot);
        }

        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotName_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotName_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotCost_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotCost_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotOfficeFee_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotOfficeFee_' + sidepotIndex, Validators.required));        
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotAdded_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotAdded_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotMaxEntries_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotMaxEntries_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotMaxEntriesPerContestant_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotMaxEntriesPerContestant_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeFloor_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeFloor_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeCap_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeCap_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeFloor_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeFloor_' + sidepotIndex, Validators.required));
        this.rodeoSettingsForm.registerControl('rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeCap_' + sidepotIndex, new FormControl('rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeCap_' + sidepotIndex, Validators.required));

        this.validationMessages.push(
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotName_' + sidepotIndex, type: 'required', message: 'Sidepot name is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotCost_' + sidepotIndex, type: 'required', message: 'Sidepot cost is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotAdded_' + sidepotIndex, type: 'required', message: 'Sidepot added money is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotMaxEntries_' + sidepotIndex, type: 'required', message: 'Sidepot max entries is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotMaxEntriesPerContestant_' + sidepotIndex, type: 'required', message: 'Sidepot max entries per contestant is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeFloor_' + sidepotIndex, type: 'required', message: 'Sidepot Male Age Floor is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotMaleAgeCap_' + sidepotIndex, type: 'required', message: 'Sidepot Male Age Cap is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeFloor_' + sidepotIndex, type: 'required', message: 'Sidepot Female Age Floor is required.' },
            { name: 'rodeoEvent_' + rodeoIndex + '_sidepotFemaleAgeCap_' + sidepotIndex, type: 'required', message: 'Sidepot Feale Age Cap is required.' },
        );
    }

    removeSidepot(sidepot: Sidepot, rodeoEvent: RodeoEvent) {
        rodeoEvent.sidepots = rodeoEvent.sidepots.filter(x => x != sidepot);
    }

    hasScheduleWithName(a: RodeoEventSchedule, b: RodeoEventSchedule) {
        return a.name === b.name;
    }

    applyTimezone(date: string) {
        if (date)
            return new Date(new Date(date).getTime()).toISOString();
        else
            return date;
    }

    checkArenaHide(event) {
        if (this.searchBox && !this.searchBox.searchBox.nativeElement.contains(event.target) && !this.arenaSearch.nativeElement.contains(event.target))
            this.searchBoxVisible = false;
    }

    updateArena(event) {
        if (event.name === "") {
            this.rodeo.arena.id = -1;
        } else {
            this.rodeo.arena = event;
        }

        this.searchBoxVisible = false;
    }

    showSearchBox() {
        this.searchBoxVisible = true;
        setTimeout(() => {
            this.searchBox.onSearchChange(null, this.rodeo.arena.name);
        })
    }

    selectArena(data: Arena) {
        this.rodeo.arena = data;
    }

    delete() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alert.create({
            title: 'Confirm Rodeo Removal',
            message: 'Do you want to remove ' + this._rodeo.name + '?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        let loader = this.loadingController.create({
                            content: 'Deleting rodeo...',
                        });

                        loader.present();

                        this.rodeoService.deleteRodeo(this._rodeo.id)
                            .then(data => {
                                loader.dismiss();
                                if (data && (data as any).message !== undefined)
                                    this.alertMessager.showError("Delete Error", (data as any).message);
                                else {
                                    this.nav.pop();
                                }
                            }, error => {
                                loader.dismiss();
                                this.alertMessager.showError("Rodeo Delete Error", error);
                            });
                    }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    agreementFileChangeListener($event): void {
        this.agreementFile = $event.target.files[0];
        this.uploadAgreementFile();
    }

    uploadAgreementFile() {
        if (this.popoverActive)
            return;

        let loader = this.loadingController.create({
            content: 'Uploading Agreement...',
        });

        loader.present();
        this.popoverActive = true;
        let fileName = (this._rodeo.organization ? this._rodeo.organization.name : this._rodeo.name) + "_contestantAgreement.pdf";

        this.imageService.uploadFile(this.agreementFile, fileName)
            .then(data => {
                loader.dismiss();
                this.popoverActive = false;
                this._rodeo.agreementFileName = fileName;
            }, error => {
                loader.dismiss();
                this.popoverActive = false;
                this.alertMessager.showError("Agreement Upload Error: ", error);
            });
    }

    updateRopingFormat(rodeoEvent) {
        rodeoEvent.pickAmount = 1;

        if (rodeoEvent.ropingFormat == 'Draw') {
            rodeoEvent.pickAmount = 0;
            rodeoEvent.allowDrawAll = 1;
        }

        if (rodeoEvent.ropingFormat == 'PickOrDraw') {
            rodeoEvent.drawAmount = 1;
            rodeoEvent.allowDrawAll = 1;
        } else if (rodeoEvent.ropingFormat == 'PickAndDraw') {
            if (!rodeoEvent.drawAmount)
                rodeoEvent.drawAmount = 1;

            rodeoEvent.allowDrawAll = 0;
        } else if (rodeoEvent.ropingFormat != 'Draw') {
            rodeoEvent.allowDrawAll = 0;
        }
    }

    clone() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alert.create({
            title: 'Confirm Rodeo Clone',
            message: 'Do you want to clone ' + this._rodeo.name + '?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        let loader = this.loadingController.create({
                            content: 'Cloning rodeo...',
                        });

                        loader.present();
                        this.submitAttempt = true;

                        if (this.selectedTimeZone === 'Not Selected') {
                            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            
                            const matchedTimezone = this.dateHelper.mapToSupportedTimeZone(userTimeZone);

                            if (matchedTimezone) {
                                this.selectedTimeZone = matchedTimezone;
                            }
                        }
                        this.rodeo.rodeoTimezone = this.selectedTimeZone;

                        this.formatDatesToUTC();

                        let savingRodeo = JSON.parse(JSON.stringify(this._rodeo));

                        savingRodeo.id = 0;
                        savingRodeo.name = savingRodeo.name + ' (Clone)';
                        savingRodeo.drawn = 0;
                        savingRodeo.published = 0;
                        savingRodeo.notifiedContestants = false;

                        if (savingRodeo.secretary == 'Cash Only')
                            savingRodeo.secretary = null;

                        let index = 0;
                        let error = false;
                        savingRodeo.rodeoEvents.forEach((rodeoEvent) => {
                            if (error)
                                return;

                            if (rodeoEvent.horseAgeFloor > rodeoEvent.horseAgeCap) {
                                this.alertMessager.showError("Rodeo Save Error", "Horse Min Age is higher than Horse Max Age");
                                error = true;
                                return;
                            }

                            if (rodeoEvent.schedules.length == 0) {
                                this.alertMessager.showError("Rodeo Save Error", "You must add a Performance to " + rodeoEvent.displayName + " before saving.");
                                error = true;
                                return;
                            }

                            rodeoEvent.carryOvers = [];

                            if (this.carryOvers[index]) {
                                this.carryOvers[index].forEach((carryOver) => {
                                    rodeoEvent.carryOvers.push(carryOver);
                                });
                            }

                            rodeoEvent.sidepots.forEach((sidepot) => {
                                if (sidepot.payoutFormat) {
                                    sidepot.payoutFormatId = sidepot.payoutFormat.id;
                                }
                            });

                            rodeoEvent.schedules.forEach((schedule) => {
                                schedule.published = 0;
                                schedule.stockPublished = 0;
                            })

                            rodeoEvent.published = 0;
                            rodeoEvent.drawn = 0;

                            index++;
                        });

                        if (error)
                            return;

                        if (!this.rodeoSettingsForm.invalid) {
                            savingRodeo.backNumbers = [];
                            savingRodeo.rodeoExpenseItems = [];
                            savingRodeo.rodeoEvents.forEach((rodeoEvent) => {
                                rodeoEvent.eventType = rodeoEvent.eventType.split(' ').join('');
                                rodeoEvent.eventType = rodeoEvent.eventType.split('-').join('');
                                rodeoEvent.registrations = [];
                                rodeoEvent.winners = [];

                                rodeoEvent.roundStyleId = rodeoEvent.roundStyle.id;

                                rodeoEvent.registrations = [];
                                rodeoEvent.schedules.forEach(schedule => {
                                    schedule.scheduledDate = schedule.scheduledDate;
                                    schedule.runs = [];
                                });

                                if (rodeoEvent.cutOffTimes && typeof rodeoEvent.cutOffTimes != "string") {
                                    rodeoEvent.cutOffTimes = (rodeoEvent.cutOffTimes as Array<string>).join(",");
                                }

                                if (rodeoEvent.divisionOffsets && typeof rodeoEvent.divisionOffsets != "string") {
                                    rodeoEvent.divisionOffsets = (rodeoEvent.divisionOffsets as Array<string>).join(",");
                                }

                                rodeoEvent.sidepots.forEach((sidepot) => {
                                    if (sidepot.divisionOffsets && typeof sidepot.divisionOffsets != "string") {
                                        sidepot.divisionOffsets = (sidepot.divisionOffsets as Array<string>).join(",");
                                    }
                                });
                            });

                            savingRodeo.payoutConfigs.forEach((payoutConfig) => {
                                payoutConfig.id = 0;

                                payoutConfig.sources.forEach(source => {
                                    source.id = 0;
                                });

                                if (payoutConfig.divisionOffsets && typeof payoutConfig.divisionOffsets != "string") {
                                    payoutConfig.divisionOffsets = (payoutConfig.divisionOffsets as Array<string>).join(",");
                                }

                                if (payoutConfig.manualPayoutsArray && payoutConfig.manualPayoutsArray.length > 0) {
                                    payoutConfig.manualPayouts = payoutConfig.manualPayoutsArray.join(',');
                                }

                                if (payoutConfig.payoutConfigPointSeries) {
                                    payoutConfig.payoutConfigPointSeries.forEach(pcPointSeries => {
                                        pcPointSeries.payoutConfigId = 0;
                                        pcPointSeries.pointSeries = null;
                                    });
                                }
                            });

                            let sanctionedOrgs = savingRodeo.sanctionedOrganizations;

                            savingRodeo.sanctionedOrganizations = [];
                            sanctionedOrgs.forEach(sanctionedOrg => {
                                savingRodeo.sanctionedOrganizations.push({ organization: sanctionedOrg, organizationId: sanctionedOrg.id });
                            });

                            savingRodeo.exhibitions.forEach(exhibition => {
                                exhibition.id = 0;
                            })

                            this.rodeoService.createRodeo(savingRodeo)
                                .then(data => {
                                    loader.dismiss();

                                    if ((data as any).message !== undefined)
                                        this.alertMessager.showError("Clone Error", (data as any).errorMessage);
                                    else {
                                        this.rodeo = data as Rodeo;

                                        this.toastController.create({
                                            message: savingRodeo.name + " saved!",
                                            duration: 3000,
                                            position: 'middle',
                                        }).present();
                                    }
                                }, error => {
                                    loader.dismiss();
                                    this.alertMessager.showError("Clone Error", error);
                                });
                        }

                    }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }

    save() {
        this.submitAttempt = true;

        if (this.selectedTimeZone === 'Not Selected') {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const matchedTimezone = this.dateHelper.mapToSupportedTimeZone(userTimeZone);

            if (matchedTimezone) {
                this.selectedTimeZone = matchedTimezone;
            }
        }
        this.rodeo.rodeoTimezone = this.selectedTimeZone;

        this.formatDatesToUTC();

        let savingRodeo = JSON.parse(JSON.stringify(this._rodeo));

        if (savingRodeo.secretary == 'Cash Only')
            savingRodeo.secretary = null;

        let index = 0;
        let error = false;
        savingRodeo.rodeoEvents.forEach((rodeoEvent) => {
            if (error)
                return;

            if (rodeoEvent.horseAgeFloor > rodeoEvent.horseAgeCap) {
                this.alertMessager.showError("Rodeo Save Error", "Horse Min Age is higher than Horse Max Age");
                error = true;
                return;
            }

            if (rodeoEvent.schedules.length == 0) {
                this.alertMessager.showError("Rodeo Save Error", "You must add a Performance to " + rodeoEvent.displayName + " before saving.");
                error = true;
                return;
            }

            if (rodeoEvent.payoutConfigs) {
                rodeoEvent.payoutConfigs.forEach(payoutConfig => {
                    if (payoutConfig.id < 0) {
                        payoutConfig.id = 0;
                    }
                 })
            }

            rodeoEvent.carryOvers = [];

            if (this.carryOvers[index]) {
                this.carryOvers[index].forEach((carryOver) => {
                    rodeoEvent.carryOvers.push(carryOver);
                });
            }

            rodeoEvent.sidepots.forEach((sidepot) => {
                if (sidepot.payoutFormat) {
                    sidepot.payoutFormatId = sidepot.payoutFormat.id;
                }
            });

            if (rodeoEvent.ropingFormat != 'Pick') {
                rodeoEvent.drawAmount = Math.max(rodeoEvent.drawAmount, 1);
            }

            index++;
        });

        if (error)
            return;

        if (!this.rodeoSettingsForm.invalid) {
            let loader = this.loadingController.create({
                content: 'Saving rodeo...',
            });

            loader.present();

            savingRodeo.rodeoEvents.forEach((rodeoEvent) => {
                rodeoEvent.eventType = rodeoEvent.eventType.split(' ').join('');
                rodeoEvent.eventType = rodeoEvent.eventType.split('-').join('');

                rodeoEvent.roundStyleId = rodeoEvent.roundStyle.id;

                rodeoEvent.registrations = [];
                rodeoEvent.schedules.forEach(schedule => {
                    schedule.runs = [];
                });

                if (rodeoEvent.eventType === 'SatBarrelRacing')
                    rodeoEvent.eventType = 'BarrelRacingSat';
                else if (rodeoEvent.eventType === 'ThursBarrelRacing')
                    rodeoEvent.eventType = 'BarrelRacingThurs';
                else if (rodeoEvent.eventType === 'FriBarrelRacing')
                    rodeoEvent.eventType = 'BarrelRacingFri';

                if (rodeoEvent.cutOffTimes && typeof rodeoEvent.cutOffTimes != "string") {
                    rodeoEvent.cutOffTimes = (rodeoEvent.cutOffTimes as Array<string>).join(",");
                }

                if (rodeoEvent.divisionOffsets && typeof rodeoEvent.divisionOffsets != "string") {
                    rodeoEvent.divisionOffsets = (rodeoEvent.divisionOffsets as Array<string>).join(",");
                }

                rodeoEvent.sidepots.forEach((sidepot) => {
                    if (sidepot.divisionOffsets && typeof sidepot.divisionOffsets != "string") {
                        sidepot.divisionOffsets = (sidepot.divisionOffsets as Array<string>).join(",");
                    }
                });
            });

            savingRodeo.payoutConfigs.forEach((payoutConfig) => {
                if (payoutConfig.id < 0) {
                    payoutConfig.id = 0;
                }

                if (payoutConfig.divisionOffsets && typeof payoutConfig.divisionOffsets != "string") {
                    payoutConfig.divisionOffsets = (payoutConfig.divisionOffsets as Array<string>).join(",");
                }

                if (payoutConfig.manualPayoutsArray && payoutConfig.manualPayoutsArray.length > 0) {
                    payoutConfig.manualPayouts = payoutConfig.manualPayoutsArray.join(',');
                }
            });

            let sanctionedOrgs = savingRodeo.sanctionedOrganizations;

            savingRodeo.sanctionedOrganizations = [];
            sanctionedOrgs.forEach(sanctionedOrg => {
                savingRodeo.sanctionedOrganizations.push({ rodeoId: savingRodeo.id, organization: sanctionedOrg, organizationId: sanctionedOrg.id });
            });

            if (!savingRodeo.id) {
                this.rodeoService.createRodeo(savingRodeo)
                    .then(data => {
                        this.saveAccountGroupLists(data as Rodeo);

                        if (this.selectedRodeoEvent && this.selectedRodeoEvent !== 'All') {
                            this.selectedRodeoEvent = (data as Rodeo).rodeoEvents.find(x => x.displayName === this.selectedRodeoEvent.displayName);
                        }

                        loader.dismiss();

                        if ((data as any).message !== undefined)
                            this.alertMessager.showError("Save Error", (data as any).errorMessage);
                        else {                          
                            this.toastController.create({
                                message: "Rodeo saved!",
                                duration: 3000,
                                position: 'middle',
                            }).present();
                        }
                    }, error => {
                        loader.dismiss();
                        this.alertMessager.showError("Rodeo Save Error", error);
                    });
            } else {                
                this.rodeoService.updateRodeo(savingRodeo)
                    .then(data => {
                        this.saveAccountGroupLists(data as Rodeo);

                        if (this.selectedRodeoEvent && this.selectedRodeoEvent !== 'All') {
                            this.selectedRodeoEvent = (data as Rodeo).rodeoEvents.find(x => x.id === this.selectedRodeoEvent.id);
                        }

                        loader.dismiss();

                        if ((data as any).errorMessage !== undefined)
                            this.alertMessager.showError("Update Error", (data as any).errorMessage);
                        else {
                            this.toastController.create({
                                message: "Rodeo saved!",
                                duration: 3000,
                                position: 'middle',
                            }).present();
                        }
                    }, error => {
                        loader.dismiss();
                        this.alertMessager.showError("Rodeo Update Error", error.error);
                    });
            }
        }
    }

    deleteEvent() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        if (this.selectedRodeoEvent.registrations.length > 0) {
            this.alertMessager.showError("Removal Error", "You can't remove a class that has registrations.");
            this.popoverActive = false;
            return;
        }

        const removedClassName = this.selectedRodeoEvent.displayName;

        this.rodeo.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x != this.selectedRodeoEvent);
        this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];

        if (this.selectedRodeoEvent == null) {
            this.addNewEvent();
        }

        this.alertMessager.showConfirmation("Class Removed", `You have successfuly removed ${removedClassName}.`);
        this.popoverActive = false;
    }

    addNewEvent() {
        let newRodeoEvent = new RodeoEvent();
        this.setupNewRodeoEventOrders(newRodeoEvent);
        newRodeoEvent.eventType = 'BullRiding';
        newRodeoEvent.displayName = 'Bull Riding';
        newRodeoEvent.roundStyleId = 1;

        this._rodeo.rodeoEvents.push(newRodeoEvent);

        this.addRodeoEvent(newRodeoEvent, false);
        this.selectedRodeoEvent = newRodeoEvent;
    }

    setupNewRodeoEventOrders(rodeoEvent: RodeoEvent) {
        let slackOrder = 1;
        let perfOrder = 1;

        switch (rodeoEvent.eventType) {
            case "BarebackRiding":
                slackOrder = 1;
                perfOrder = 1;
                break;
            case "SaddleBroncRiding":
                slackOrder = 2;
                perfOrder = 4;
                break;
            case "TeamRoping":
                slackOrder = 9;
                perfOrder = 7;
                break;
            case "BarrelRacing":
                slackOrder = 5;
                perfOrder = 8;
                break;
            case "SteerWrestling":
                slackOrder = 6;
                perfOrder = 2;
                break;
            case "Tie-Down":
                slackOrder = 8;
                perfOrder = 5;
                break;
            case "BreakawayRoping":
                slackOrder = 7;
                perfOrder = 3;
                break;
            case "BullRiding":
                slackOrder = 4;
                perfOrder = 9;
                break;
            case "RanchBroncRiding":
                slackOrder = 3;
                perfOrder = 6;
                break;
            default:
                slackOrder = perfOrder = 1;
        }

        rodeoEvent.eventOrders.push(RodeoEventOrder.create(0, true, slackOrder));
        rodeoEvent.eventOrders.push(RodeoEventOrder.create(0, false, perfOrder));

        return rodeoEvent;
    }

    addJudge(viewMode: 'judge' | 'categories', rodeoEvent: RodeoEvent = null, penalty: boolean = false, data: any = null) {
        //rodeoEventId = null for all
        //data is existing judge (for edit)
        const popup = this.popoverController.create(JudgePopup, {
            viewMode,
            rodeoId: this.rodeo.id,
            rodeoEvent,
            penalty: penalty,
            data
        }, {
            cssClass: 'page-payout-config'
        });

        popup.present();

        popup.onDidDismiss(data => {
            // console.log('dismiss', data);
            if (data) {
                this.getJudges(-1);
            }
        })
        // this.judges = {
        //     0: [{
        //         accountId: 1234,
        //         rodeoEventId: this.rodeo.rodeoEvents[0].id,
        //         rodeoId: this.rodeo.id
        //     }]
        // };
    }

    removeJudge(judge: Judge, wasPrompted: boolean = false) {
        if (!judge.rodeoEventId && !wasPrompted) {
            //this judge will be deleted for all events
            this.alertMessager.prompt('Remove Judge', 'This judge will be deleted for all events.', () => {
                this.removeJudge(judge, true);
            });
            return;
        }

        this.judgeService.deleteJudge(judge.id)
            .then(() => {
                this.toastController.create({
                    message: 'Judge has been removed.',
                    duration: 3000
                }).present();
                this.getJudges(-1);
            });
    }

    getJudges(rodeoEventId) {
        if (this.judges && rodeoEventId > -1) {
            const judges = [];
            judges.push(...this.judges[rodeoEventId] || []);
            if (this.judges[-1]) {
                judges.push(...this.judges[-1]);
            }
            return judges;
        } else {
            this.judgeService.getJudges(this.rodeo.id).then(judges => {
                // console.log(judges);
                const judgeHash = {};
                judges.forEach(judge => {
                    if (judgeHash[judge.rodeoEventId || -1]) {
                        judgeHash[judge.rodeoEventId || -1].push(judge);
                    } else {
                        judgeHash[judge.rodeoEventId || -1] = [judge];
                    }
                });
                this.judges = judgeHash;
            });

            this.judgeService.getJudgeCategories(this.rodeo.id).then(categories => {
                const categoriesHash = {};
                const penaltiesHash = {};
                this.rodeo.rodeoEvents.forEach(rodeoEvent => {
                    categoriesHash[rodeoEvent.id] = categories.filter(x => (x.rodeoEventId == rodeoEvent.id || !x.rodeoEventId) && x.penalty == false);
                    penaltiesHash[rodeoEvent.id] = categories.filter(x => (x.rodeoEventId == rodeoEvent.id || !x.rodeoEventId) && x.penalty == true);
                });
                this.judgeCategories = categoriesHash;
                this.judgePenalties = penaltiesHash;
                
            });
        }
    }

    removeCategory(category: JudgeCategory, wasPrompted: boolean = false) {
        if (!category.rodeoEventId && !wasPrompted) {
            //this judge will be deleted for all events
            this.alertMessager.prompt('Remove Category', 'This category will be deleted for all events.', () => {
                this.removeCategory(category, true);
            });
            return;
        }

        this.judgeService.deleteCategory(category.id)
            .then(() => {
                this.toastController.create({
                    message: 'Category has been removed.',
                    duration: 3000,
                    position: 'middle'
                }).present();
                this.getJudges(-1);
            });
    }

    setTotalsCalculation(rodeoEvent: RodeoEvent, useAverage: boolean) {
        this.judgeService.setTotalsCalculation(rodeoEvent.id, useAverage)
            .then(() => {
                rodeoEvent.averageJudgeTotalScores = useAverage;
                this.toastController.create({
                    message: 'Setting saved!',
                    duration: 3000,
                    position: 'middle',
                }).present();
            })
            .catch(err => {
                this.toastController.create({
                    message: 'Could not save setting.',
                    duration: 2500,
                    position: 'middle'
                }).present();
            });
    }

    addNewPriceTier(rodeoIndex: number) {
        const rodeoEvent = this._rodeo.rodeoEvents[rodeoIndex];

        let priceTier = {
            id: undefined,
            rodeoId: this._rodeo.id,
            rodeoEventId: this._rodeo.rodeoEvents[rodeoIndex].id,
            organizationId: this._rodeo.organization.id,
            productId: 1, //rodeo entry
            startDate: this.dateHelper.stripTimezone(this._rodeo.registrationStartDate),
            endDate: this.dateHelper.stripTimezone(this._rodeo.registrationEndDate),
            tierName: 'Standard',
            unitPrice: rodeoEvent.entryCost || 100,
            isActive: true
        } as PriceTier;


        if (!rodeoEvent.priceTiers || rodeoEvent.priceTiers.length == 0) {
            rodeoEvent.priceTiers = [];
        } else {
            //look for duplicate default tier name
            const existingTier = rodeoEvent.priceTiers.find(x => x.tierName == priceTier.tierName);
            if (existingTier) {
                if (!rodeoEvent.priceTiers.find(x => x.tierName == 'Early Bird')) {
                    const startDate = new Date(priceTier.startDate);
                    const newEndDate = new Date(priceTier.startDate);
                    newEndDate.setDate(startDate.getDate() + 14); //default to 2 weeks early
                    priceTier.tierName = 'Early Bird';
                    let timeString = newEndDate.toISOString();
                    timeString = timeString.substring(0, timeString.indexOf('.'));
                    priceTier.endDate = timeString;
                    existingTier.startDate = timeString;
                } else {
                    priceTier.tierName = 'New Tier';
                    priceTier.endDate = '';
                    priceTier.startDate = '';
                }
            }
        }

        rodeoEvent.priceTiers.push(priceTier);
    }

    removePriceTier(tier, rodeoEvent) {
        rodeoEvent.priceTiers = rodeoEvent.priceTiers.filter(x => x != tier);

        if (rodeoEvent.priceTiers.length == 1) {
            rodeoEvent.priceTiers[0].startDate = this.dateHelper.stripTimezone(this._rodeo.registrationStartDate);
            rodeoEvent.priceTiers[0].endDate = this.dateHelper.stripTimezone(this._rodeo.registrationEndDate);
        }
    }

    getFullName(account: Account): string {
        const firstName = account.firstName || '';
        const lastName = account.lastName || '';
        return `${firstName} ${lastName}`;
    }

    async showUserSearch(accountGroup: string) {

        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0 && data.buddies[0] !== undefined) {
                this.updateAccountList(accountGroup, data.buddies);
            }
        }
        
        this.userSearch('User Search', callback);
    }

    userSearch(title, callback, allowDraw = false, allowTba = false) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: title,
            organization: this.rodeo.organization,
            allowDraw: allowDraw,
            allowTba: allowTba,
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    async removeStaff(accountGroup: string, accountId: number) {
        if (this.popoverActive) {
            return;
        }

        this.popoverActive = true;

        let account = this.staffMap[accountId];

        if (!account) {
            const dbAccount = await this.userService.getAccount(accountId) as Account;
            account.name = `${dbAccount.firstName}  ${dbAccount.lastName}`;
        }

        const accountName = account ? `${account.name}` : 'Unknown';

        let alert = this.alert.create({
            title: 'Staff Removal Confirmation',
            message: `Are you sure you want to delete ${accountName} from ${accountGroup}?`,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { },
                },
                {
                    text: 'Yes',
                    role: 'confirm',
                    handler: () => {
                        let currentGroup = accountGroup === 'secretaries' ? this.rodeoSecretaries.getValue() : this.rodeoContractors.getValue();
                        currentGroup.accounts = currentGroup.accounts.filter((x) => x.accountOneId !== accountId);
                    },
                },
            ],
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        });
    
    }

    private async saveAccountGroupLists(rodeo: Rodeo) {
        if (this.rodeoSecretaries.getValue().id == 0) {
            this.rodeoSecretaries.getValue().name = `Rodeo_${rodeo.id}_Secretaries`;
        }
        this.saveAccountGroupList(this.rodeoSecretaries.getValue());

        if (this.rodeoContractors.getValue().id == 0) {
            this.rodeoContractors.getValue().name = `Rodeo_${rodeo.id}_Contractors`;
        } 
        this.saveAccountGroupList(this.rodeoContractors.getValue());
    }

    private saveAccountGroupList(accountGroup: AccountGroup) {
        if (accountGroup.id == 0) {
            this.accountGroupService.create(accountGroup);
        } else {
            this.accountGroupService.update(accountGroup);
        }
    }

    private updateAccountList(accountGroup: string, selectedAccounts?: Account[]) {
        let subject = accountGroup === 'secretaries' ? this.rodeoSecretaries : this.rodeoContractors;
        const currentGroup = subject.getValue();

        if (selectedAccounts) {
            for (const account of selectedAccounts) { 
                if (!this.staffMap[account.id]) {
                    this.staffMap[account.id] = {
                        name: `${account.firstName} ${account.lastName}`,
                        email: account.emailAddress || 'N/A',
                        phone: account.phone || 'N/A'
                    };
                }
            }
            const formattedSelectedAccounts = selectedAccounts.map(x => new AccountsGroup(x, undefined, currentGroup.id));
            currentGroup.accounts = [...currentGroup.accounts, ...formattedSelectedAccounts];
        }
    }

    private mapGroupAccounts(group: AccountGroup) {
        if (!group.accounts || group.accounts.length === 0) {
            return;
        }

        group.accounts.forEach(async x => {
            let staffAccount = this.staffMap[x.id] ? this.staffMap[x.id] : undefined
            let account = x.accountOne ? x.accountOne : undefined;
            
            if (!staffAccount && !account) {
                account = await this.userService.getAccount(x.accountOneId) as Account;
                // console.log('db info', account);
            }

            if (account && !staffAccount) {
                this.staffMap[x.accountOneId] = {
                    name: `${account.firstName} ${account.lastName}`,
                    email: account.emailAddress,
                    phone: account.phone
                };
            }
        })
    }

    private createRodeoStaffGroup(accountGroup: string, save: boolean = false) {
        let newGroup = accountGroup === 'secretaries' ? new AccountGroup(`Rodeo_Undefined_Secretaries`) : new AccountGroup(`Rodeo_Undefined_Contractors`);

        switch (accountGroup) {
            case 'secretaries':
                newGroup = this.rodeoSecretaries.getValue() ? this.rodeoSecretaries.getValue()
                    : this.rodeo.id ? new AccountGroup(`Rodeo_${this.rodeo.id}_Secretaries`) : newGroup;

                this.rodeoSecretaries.next(newGroup);
                break;
            case 'contractors':
                newGroup = this.rodeoContractors.getValue() ? this.rodeoContractors.getValue()
                    : this.rodeo.id ? new AccountGroup(`Rodeo_${this.rodeo.id}_Contractors`) : newGroup;

                this.rodeoContractors.next(newGroup);
                break;
        }
    }

    private setFormDateFields() {
        this.dateHelper.rodeoDateFields.forEach((option) => {
            let date = this.rodeo[option];
            if (!date || date === '')
                return;
    
            const formControl = this.rodeoSettingsForm.get(option);
            if (formControl) {
                formControl.patchValue(date);
            }
        })
    
        this.rodeo.rodeoEvents.forEach((rodeoEvent, rodeoEventIndex) => {
            rodeoEvent.schedules.forEach((schedule, scheduleIndex) => {
                if (!schedule.scheduledDate || schedule.scheduledDate === '')
                    return;
        
                const formControlName = 'rodeoEvent_' + rodeoEventIndex + '_scheduleDate_' + scheduleIndex;
                    
                const formControl = this.rodeoSettingsForm.get(formControlName);
                if (formControl) {
                    formControl.patchValue(schedule.scheduledDate);
                }
            });
        });
    }

    private formatDatesToUTC() {
        const updateDateField = (field: string) => {
            const formFieldControl = this.rodeoSettingsForm.get(field);

            const date = formFieldControl && formFieldControl.value && formFieldControl.value !== field ? formFieldControl.value : this.rodeo[field];

            if (!date || date === '')
                return;

            // Convert date to selected timezone, then to UTC for saving
            this.rodeo[field] = this.dateHelper.convertDateToUTC(date, this.selectedTimeZone);
        };

        // Convert all dates before saving
        this.dateHelper.rodeoDateFields.forEach((option) => {
            updateDateField(option);
        });

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.schedules.forEach((schedule) => {
                schedule.scheduledDate = this.dateHelper.convertDateToUTC(schedule.scheduledDate, this.selectedTimeZone);
            });
        });
    }

    
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/settings.ts